export default __webpack_public_path__ + "static/rent-background-ce19c42ad545883a3d032d766e3e4fbc.jpg";